export default {
    WrapComponent: 'div',
    transitionName: 'am-slide-up',
    maskTransitionName: 'am-fade'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/picker/popupProps.js
// module id = 1277
// module chunks = 0